import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import ServicesPage from "@/pages/ServicesPage";

export const Route = createFileRoute("/services")({
  component: ServicesPageRoute,
});

function ServicesPageRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <ServicesPage />
      </Suspense>
    </PageTransition>
  );
}
